module.exports = __webpack_public_path__ + "img/altitude-room-4.3c7bcb13.jpg";